import {log} from "../common/helpers";

declare global {
  interface HTMLElement {
    rangeSlider?: boolean
  }
}

function updateRange(target: HTMLInputElement) {
  const min = target.min
  const max = target.max
  const val = target.value
  // @ts-ignore
  let percentage = (val - min) * 100 / (max - min)
  percentage = Math.round(percentage * 100) / 100

  target.style.setProperty('--range-progress', percentage + '% 100%')
}

function handleInputChange(e: InputEvent & { target: HTMLInputElement }) {
  let target = e.target
  updateRange(target)
}

function attachToElement(element: HTMLInputElement) {
  if (element.rangeSlider) {
    return
  }
  element.rangeSlider = true
  element.addEventListener('change', handleInputChange)
  element.addEventListener('input', handleInputChange)
  updateRange(element)
}

export default () => {
  const elements = document.querySelectorAll('input[type="range"]')
  if (elements.length > 0) {
    log('Range Slider Polyfil', 'Polyfilling range sliders')
    elements.forEach(attachToElement)
  }

  const observer = new MutationObserver(() => {
    const elements = document.querySelectorAll('input[type="range"]')
    elements.forEach(attachToElement)
  })
  observer.observe(document.body, { childList: true, subtree: true })
}
